module.exports = __webpack_public_path__ + "img/LogoDashboard-14.9e90cdfb.svg";